<template>
	<section>
		<div class="d-flex flex-row align-items-center justify-content-between">
			<h3 class="mb-0">Equipment</h3>

			<div v-if="!isFinalized">
				<button class="btn btn-success" v-on:click="newEquipment">
					<i class="fa fa-plus"></i>
					Add Equipment
				</button>

				<button v-if="(typeName == 'Invoice' || typeName == 'Change Order') && !hideRegenButton" class="btn btn-light ml-1" title="Regenerate Equipment" v-on:click="confirmRegen">
					<i class="fa fa-sync"></i>
				</button>
			</div>
		</div>

		<table-list
			record-name="Equipment Item"
			:fields="equipmentFields"
			:records="mutatedEquipment"
			:has-edit="!isFinalized"
			:has-delete="!isFinalized"
			:hide-record-count="true"
			v-on:edit="editEquipment"
			v-on:delete="deleteObject($event,invoiceObjectResource)">

		</table-list>

		<equipment-type-picker-modal
		 	:visible="equipmentEditModal.visible"
		 	:title="equipmentEditModal.title"
		 	:record="equipmentEditModal.selectedType"
		 	:allow-manual-type="true"
		 	v-on:confirmAdd="confirmAdd"
		 	v-on:closeModal="equipmentEditModal.visible = false">
		</equipment-type-picker-modal>
	</section>
</template>
<script type="text/javascript">
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import ModalDialog from "@/components/ModalDialog"
import EquipmentTypePickerModal from "@/components/super_components/EquipmentTypePickerModal"

import InvoiceMixins from "@/mixins/InvoiceMixins.js"

export default {
	name: "InvoiceEquipmentSection",
	components: {
		Field,
		TableList,
		ModalDialog,
		EquipmentTypePickerModal,
		FormGroup
	},
	mixins: [InvoiceMixins],
	props: ["invoiceEquipment","invoiceId","typeName","hideRegenButton","isFinalized","invoiceObjectResource"],
	data() {
		return {
			equipmentTypes: [],
			equipmentFields: [
				{label: "Type",key:"typeName"},
				{label: "Qty", key:"qtyWithUnit",align:"right"},
				{label: "Rate",key:"rate",align:"right"},
				{label: "Total",key:"total",align:"right"}
			],
			equipmentEditModal: {
				visible: false,
				title: "Edit Equipment",
				selectedType: null,
				payload: {},
				lineTotal: 0,
			}
		}
	},
	computed: {
		mutatedEquipment() {
			let vm = this

			return this.invoiceEquipment.map(type => {

				let rate = +type.rate
				let unit = "hour"
				if ("unit" in type)
					unit = type.unit
				else if ("qty_unit" in type)
					unit = type.qty_unit

				if (unit == 'hours' || unit == 'hrs')
					unit = "hour"
				else if (unit == 'days')
					unit = "day"

				type.qty = +type.qty

				if (rate)
					type.rate = rate.toCurrency()
				else
					type.rate = "0.00"

				if (!type.rate)
					type.rate = 0
				
				type.total = rate * type.qty

				type.qty = type.qty.toFixed(2)
				type.total = type.total.toCurrency()

				type.qtyWithUnit = type.qty + " " + unit + "s"

				return type
			})
		},
	},
	methods: {
		editEquipment(record) {
			this.equipmentEditModal.visible = true
			this.equipmentEditModal.title = "Edit Equipment"
			this.equipmentEditModal.payload = JSON.parse(JSON.stringify(record))

			this.equipmentEditModal.selectedType = {
				type_name: record.typeName,
				type_id: record.equipment_type_id,
				rate: record.rate,
				qty: record.qty,
				unit: record.unit,
			}

			this.equipmentEditModal.payload.type = "Equipment"

			try {
				this.equipmentEditModal.selectedType.multiRates = JSON.parse(record.charge_out_rates_json)
			}
			catch (e) {}

			this.equipmentEditModal.payload.invoice_id = this.invoiceId
		},
		newEquipment() {
			this.equipmentEditModal.visible = true
			this.equipmentEditModal.title = "Add Equipment to "+this.typeName

			this.equipmentEditModal.selectedType = {
				rate: "",
				hrs: ""
			}
			this.equipmentEditModal.payload = {
				invoice_id: this.invoiceId,
				type: "Equipment",
				equipment_type_id: null,
				unit: "hour",
				rate: "",
				qty: ""
			}
		},
		confirmAdd(payload) {
			let total = +payload.qty * +payload.rate

			this.equipmentEditModal.payload.rate = payload.rate 
			this.equipmentEditModal.payload.qty = payload.qty
			this.equipmentEditModal.payload.unit = payload.unit
			this.equipmentEditModal.payload.equipment_type_id = payload.equipment_type_id

			this.equipmentEditModal.payload.total = total.toCurrency()
			this.equipmentEditModal.payload.totalRaw = total

			this.equipmentEditModal.payload.name = payload.typeName
			this.equipmentEditModal.payload.typeName = payload.typeName

			if ("multiRates" in payload)
				this.equipmentEditModal.payload.multiRates = payload.multiRates

			this.saveObject(this.equipmentEditModal,false,this.invoiceObjectResource)
		},
		fetchData() {
			let vm = this

			let promises = [
				this.getJSON("EquipmentType/get")
			]

			Promise.all(promises).then(responses => {
				if (responses[0].success) {
					vm.equipmentTypes = responses[0].data
				}
			})
		}
	},
	created() {
		this.fetchData()
	}
}
</script>